import * as Tone from 'tone'
import { publicPath } from 'global_env'

const baseUrl= `https://sounds.lamusi.de`
export const Woodblock = new Tone.Player(
  //`${publicPath}assets/instrument_samples/woodblock/Korg-N1R-Low-Wood-Block.wav`,
  `${baseUrl}/woodblock/Korg-N1R-Low-Wood-Block.wav`,
).toDestination()